import type { ReactNode } from 'react';

interface ZoneProps {
  side: 'left' | 'right';
  visible: boolean;
  width: string;
  children: ReactNode;
  className?: string;
}

export default function Zone({ side, visible, width, children, className = '' }: ZoneProps) {
  return (
    <div
      className={`min-w-0 ${visible ? width : 'w-0'} shrink-0 transition-[width] duration-300 ${side === 'left' ? 'border-r' : 'border-l'} border-border/30 ${className}`}
      aria-hidden={!visible}
    >
      {children}
    </div>
  );
}
